import web from "@/core/middlewares/web";

let groups = () => import(/* webpackChunkName: "publishers" */ '@/views/publishers/Groups');
let index = () => import(/* webpackChunkName: "publishers" */ '@/views/publishers/Index');

export default [
    {
        path: "publisher-groups",
        name: "publishers.groups.index",
        component: groups,
        meta: {
            middleware: web,
            permissions: ['publisher-groups:viewAny'],
            title: "گروه انتشارات"
        }
    },
    {
        path: "publisher-groups/:groupId/publishers",
        name: "publishers.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['publishers:viewAny'],
            title: "انتشارات"
        }
    }
]
